<template>
  <div v-if="finance !== null">
    <vx-card title="Cálculos de cliente">
      <table class="table">
        <tr>
          <th v-if="variant !== 'non-title'"></th>
          <th style="width: 150px;">Valor</th>
          <th style="width: 150px;" v-if="compare !== null">Simulación</th>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Fecha de primer pago</td>
          <td style="width: 150px;" v-if="amortization.length > 0">
            <span class="copy">{{amortization[0].payment_date}}
            </span>
          </td>
          <td style="width: 150px;" v-if="compare !== null">
            <span class="copy">{{ compare.amortization[0].payment_date }}</span>
          </td>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Periodo de entrega (Meses)</td>
              <td style="width: 150px;"><span class="copy">{{ finance.delivery_term }}</span>
          </td>
          <td style="width: 150px;" v-if="compare !== null">
            <span class="copy">{{ compare.finance.delivery_term }}</span>
          </td>
        </tr>
        <tr>
          <td>Tasa</td>
          <td>
            <span class="copy">
                {{ (finance.annual_interest_percentage * 100)|toFixed }}
            </span> %
          </td>
          <td v-if="compare !== null">
            <span class="copy">
                {{ (compare.finance.annual_interest_percentage * 100)|toFixed }}
            </span> %
          </td>
        </tr>
        <tr>
          <td>CAT</td>
          <td>
            <span class="copy">
                {{ finance.cat|toFixed }}
            </span> %
          </td>
          <td v-if="compare !== null">
            <span class="copy">
                {{ compare.finance.cat|toFixed }}
            </span> %
          </td>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Intereses financiados</td>
          <td><span class="copy">{{ finance.financed_interests|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.financed_interests|currency }}</span>
          </td>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Pago Entrega</td>
          <td><span class="copy">{{ finance.delivery_term_period_payment|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.delivery_term_period_payment|currency }}</span>
          </td>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Enganche ($)</td>
          <td><span class="copy">{{ finance.deposit|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.deposit|currency }}</span>
          </td>
        </tr>
        <!--<tr>
          <td v-if="variant !== 'non-title'">Pago inicial</td>
          <td><span class="copy">{{ finance.initial_payment|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.initial_payment|currency }}</span>
          </td>
        </tr>-->
        <tr>
          <td v-if="variant !== 'non-title'">Restante</td>
          <td>
            <span class="copy">
              {{ balance(finance.total_cost, finance.deposit)|currency }}
            </span>
          </td>
          <td v-if="compare!== null">
            <span class="copy">{{ balance(compare.finance.total_cost, compare.finance.deposit)|currency }}</span>
          </td>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Mensualidad</td>
          <td><span class="copy">{{ finance.monthly_payment|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.monthly_payment|currency }}</span>
          </td>
        </tr>
        <tr class="bg-grey text-white">
          <td colspan="3">
            Comisiones
          </td>
        </tr>
        <template v-if="loanVersion === 'v1'">
          <tr class="bg-dark text-white">
            <td v-if="variant !== 'non-title'">- Por gastos de originación + IVA</td>
            <td><span class="copy">{{ finance.openning_comission|currency }}</span></td>
            <td v-if="compare !== null">
              <span class="copy">{{ compare.finance.openning_comission|currency }}</span>
            </td>
          </tr>
          <tr class="bg-dark text-white">
            <td v-if="variant !== 'non-title'">- Por manejo de cuentas + IVA</td>
            <td><span class="copy">{{ finance.ensurance|currency }}</span></td>
            <td v-if="compare !== null">
              <span class="copy">{{ compare.finance.ensurance|currency }}</span>
            </td>
          </tr>
          <tr class="bg-dark text-white">
            <td v-if="variant !== 'non-title'">- Por apertura + IVA</td>
            <td><span class="copy">{{ finance.admon_comission|currency }}</span></td>
            <td v-if="compare !== null">
              <span class="copy">{{ compare.finance.admon_comission|currency }}</span>
            </td>
          </tr>
        </template>
        <template v-if="loanVersion === 'v2'">
          <tr class="bg-dark text-white">
            <td v-if="variant !== 'non-title'">- Por gastos de pre-originación + IVA</td>
            <td><span class="copy">{{ finance.applicant_fee_1|currency }}</span></td>
            <td v-if="compare !== null">
              <span class="copy">{{ compare.finance.applicant_fee_1|currency }}</span>
            </td>
          </tr>
          <tr class="bg-dark text-white">
            <td v-if="variant !== 'non-title'">- Por gastos de contratación + IVA</td>
            <td><span class="copy">{{ finance.applicant_fee_2|currency }}</span></td>
            <td v-if="compare !== null">
              <span class="copy">{{ compare.finance.applicant_fee_2|currency }}</span>
            </td>
          </tr>
        </template>
        <tr>
          <td v-if="variant !== 'non-title'">Monto a financiar</td>
          <td><span class="copy">{{ finance.financed_amount|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.financed_amount|currency }}</span>
          </td>
        </tr>
        <tr>
          <td v-if="variant !== 'non-title'">Monto a depositar</td>
          <td><span class="copy">{{ finance.credit_disposal_amount|currency }}</span></td>
          <td v-if="compare !== null">
            <span class="copy">{{ compare.finance.credit_disposal_amount|currency }}</span>
          </td>
        </tr>
      </table>

      <div class="row">
        <div class="col-md-12">
          <slot name="invoice_project_pdf"></slot>
          <slot name="invoice_project_xml"></slot>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "ProjectFinanceForm",
  props: {
    loanVersion: {
      type: String,
      required: true
    },
    amortization: {
      type: Array,
      required: true
    },
    finance: {
      type: Object,
      required: true
    },
    compare: {
      type: Object,
      default: null
    },
    variant: {
      type: String,
      default: 'with-title'
    }
  },
  filters: {
    toFixed(value) {
      if (value === null)
        return 0
      return value.toFixed(2)
    }
  },
  methods: {
    balance(total_cost, deposit) {
      return total_cost - deposit
    }
  },
  mounted() {
    $(".copy").click((e) => {
      this.$copyText(e.delegateTarget.innerText);
      this.$toasted.show("Texto copiado!", {
        duration: 3000,
        position: 'bottom-right'
      })
    })
  }
}
</script>

<style scoped>

</style>
